import React from 'react';

import { useParams } from 'react-router-dom';

import useFeatureFlags from 'api/useFeatureFlags';
import { EFeatureFlag } from 'constants/enums';

import { AbbreviationsSettingsV2 } from './components/AbbreviationsSettingsV2';
import { StoreSettingsLegacy } from './StoreSettingsLegacy';

export const StoreSettings = (): React.ReactElement => {
  const { publisherId } = useParams();
  const { getFeatureFlagByKey } = useFeatureFlags({ publisherId });
  const isAbbreviationV2Enabled = Boolean(
    getFeatureFlagByKey(EFeatureFlag.DASHBOARD_ABBREVIATION_V2)
  );

  if (isAbbreviationV2Enabled) {
    return <AbbreviationsSettingsV2 />;
  }

  return <StoreSettingsLegacy />;
};
